import React, { useState } from 'react';
import './ImageLoader.css';

const ImageLoader = ({ src, alt, className, style, ...props }) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <div className={`image-loader-container ${className || ''}`} style={style}>
            {!loaded && <div className="image-loader-skeleton"></div>}
            <img
                src={src}
                alt={alt}
                className={`image-loader-img ${loaded ? 'loaded' : ''}`}
                onLoad={() => setLoaded(true)}
                loading="lazy"
                {...props}
            />
        </div>
    );
};

export default ImageLoader;
